
import { defineComponent, reactive, computed } from 'vue';
import CampoNumerico from '@/core/components/Tela/CampoNumerico.vue';
import SelecionarGenerico from '@/core/components/Tela/SelecionarGenerico.vue';
import { IOption } from '@/core/models/AntDesign/IOption';
import { INotaFiscalDetalhePagamentoCentroCusto } from '@/models/Entidades/Fiscal/INotaFiscal';
import SelecionarCategoriaPlanoConta from '@/components/Cadastros/PlanosContas/SelecionarCategoriaPlanoConta.vue';
import NotaFiscalDetalhePagamentoCentroCusto from '@/components/Fiscal/NotasFiscais/NotaFiscalDetalhePagamentoCentroCusto.vue';
import SelecionarData from '@/core/components/Tela/SelecionarData.vue';

export default defineComponent({
  name: 'RecebimentoMercadoriaPagamentoParcelado',
  props: {
    parcelas: {
      type: Array as () => IOption[],
      required: true,
    },
    qtdParcelas: {
      type: Number,
      required: true,
    },
    valorRestante: {
      type: Number,
      required: true,
    },
    valorParcelado: {
      type: Number,
      required: true,
    },
    empresa: {
      type: Number,
      required: true,
    },
    codigoPlanoConta: {
      type: Number,
      required: true,
    },
    nomePlanoConta: {
      type: String,
      required: true,
    },
    centroCustos: {
      type: Array as () => INotaFiscalDetalhePagamentoCentroCusto[],
      required: true,
    },
    dataVencimento: {
      type: String,
      required: true,
    },
  },
  components: {
    CampoNumerico,
    SelecionarGenerico,
    SelecionarCategoriaPlanoConta,
    NotaFiscalDetalhePagamentoCentroCusto,
    SelecionarData,
  },
  emits: ['update:qtdParcelas', 'update:valorParcelado', 'update:codigoPlanoConta', 'update:centroCustos', 'update:nomePlanoConta', 'update:dataVencimento'],
  setup(props, { emit }) {
    const state = reactive({});

    const computedQtdParcelas = computed({
      get: () => props.qtdParcelas,
      set: (val: number) => {
        emit('update:qtdParcelas', val);
      },
    });

    const computedValorParcelado = computed({
      get: () => props.valorParcelado,
      set: (val: number) => {
        emit('update:valorParcelado', val);
      },
    });

    const computedCodigoPlanoConta = computed({
      get: () => props.codigoPlanoConta,
      set: (val: number) => {
        emit('update:codigoPlanoConta', val);
      },
    });

    const computedCentroCustos = computed({
      get: () => props.centroCustos,
      set: (val: INotaFiscalDetalhePagamentoCentroCusto[]) => {
        emit('update:centroCustos', val);
      },
    });

    const computedNomePlanoConta = computed({
      get: () => props.nomePlanoConta,
      set: (val: string) => {
        emit('update:nomePlanoConta', val);
      },
    });

    const computedDataVencimento = computed({
      get: () => props.dataVencimento,
      set: (val: string) => {
        emit('update:dataVencimento', val);
      },
    });

    return {
      props,
      state,
      computedQtdParcelas,
      computedValorParcelado,
      computedCodigoPlanoConta,
      computedCentroCustos,
      computedNomePlanoConta,
      computedDataVencimento,
    };
  },
});
